import React, { useRef, useEffect } from 'react';
import ChatMessage from './ChatMessage';
import Suggestions from './Suggestions';
import RecapCard from './RecapCard';
import { Oval } from 'react-loader-spinner';

export default function Chat({ messages, isLoading, suggestions, pendingRecap, sendMessage }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, suggestions]);

  return (
    <div className="space-y-4">
      {messages.map((message, index) => (
        <ChatMessage key={index} message={message} />
      ))}

      {isLoading && messages[messages.length - 1]?.content === '' && (
        <div className="flex items-center gap-2 text-gray-500">
          <Oval color="#6366F1" height={20} width={20} />
          <span className="text-sm">En train d'écrire...</span>
        </div>
      )}

      {pendingRecap && (
        <RecapCard
          data={pendingRecap}
          onConfirm={() => sendMessage('Oui, je confirme')}
          onCancel={() => sendMessage('Non, je veux modifier')}
        />
      )}

      {suggestions.length > 0 && !isLoading && (
        <Suggestions suggestions={suggestions} onSelect={sendMessage} />
      )}

      <div ref={bottomRef} />
    </div>
  );
}
